var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvalBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1651,
    height: 1109,
    viewBox: "0 0 1651 1109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M675.5,0C1048.568,0,1351,181.1,1351,404.5S1048.568,809,675.5,809,0,627.9,0,404.5,302.432,0,675.5,0Z",
    transform: "translate(150 150)",
    fill: "rgba(7,61,150,0.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalBackground);
export default __webpack_public_path__ + "static/media/oval-background.eaf17ce2.svg";
export { ForwardRef as ReactComponent };